import "@/styles/marketing-auth.scss";
import { Suspense, useEffect } from "react";
import { Outlet } from "react-router-dom";

export default function AuthMarketingLayout() {
  useEffect(() => {
    const { documentElement: root, body } = document;
    root.classList.add("marketing-scroll-theme");
    body.classList.add("marketing-scroll-theme");
    return () => {
      root.classList.remove("marketing-scroll-theme");
      body.classList.remove("marketing-scroll-theme");
    };
  }, []);

  return (
    <div className="marketing-site marketing-auth">
      <Suspense
        fallback={
          <div className="container py-5 text-center text-muted">
            Loading…
          </div>
        }>
        <Outlet />
      </Suspense>
    </div>
  );
}
